import React from 'react';
import grafico1 from '../../assets/grafico1-Photoroom.png';
import grafico2 from '../../assets/grafico2-Photoroom.png';
import grafico3 from '../../assets/grafico3-Photoroom.png';
import qr from '../../assets/qr.png';
import logo from '../../assets/images/LogoNav.png';
import '../../styles/Grafica.css';

const Grafica = () => {
  return (
    <div className="medical-charts-content">
      {/* Gráfico 1 */}
      <div className="chart-section">
        <div className="chart-header-grafico1">
          Gráfico 1: Reducción del CAT (13,3 ± 12,9 puntos) <br /> - Diferencia
          media: 6,3 pts (p&lt;0,001)
        </div>
        <div className="chart-content-grafico1">
          <img
            src={grafico1}
            alt="Gráfico 1 - Reducción del CAT"
            className="chart-image-grafico1"
          />
          <p className="chart-caption-grafico1">
            <strong>Grupo de Intervención</strong> (Barra sólida pre - barra
            trama post)
            <br /> Figura 2. Comparación del puntaje CAT de los Pacientes con
            EPOC COLD-E antes y después de la intervención según grupo
          </p>
        </div>
      </div>

      {/* Gráfico 2 */}
      <div className="chart-section">
        <div className="chart-header-grafico2">
          Gráfico 2: Reducción de exacerbaciones moderadas y severas <br /> - De
          62,9 % a 27,1 % (p&lt;0,05)
        </div>
        <div className="chart-content-grafico2">
          <img
            src={grafico2}
            alt="Gráfico 2 - Reducción de exacerbaciones"
            className="chart-image-grafico2"
          />
          <p className="chart-caption-grafico2">
            Figura 3. Comparación de la proporción de exacerbaciones de EPOC
            moderadas y severas de los pacientes con EPOC GOLD-E antes y después
            de la intervención.
          </p>
        </div>
      </div>

      {/* Gráfico 3 */}
      <div className="chart-section">
        <div className="chart-header-grafico3">
          Gráfico 3: Variables clínicas y de función pulmonar medidas antes y
          después del tratamiento en los pacientes con EPOC GOLD-E según grupo
          de intervención.
        </div>
        <div className="chart-content-grafico3">
          <img
            src={grafico3}
            alt="Gráfico 3 - Variables clínicas"
            className="chart-image-grafico3"
          />
        </div>
      </div>

      {/* Footer con logo BIOMERCY */}
      <div className="footer-grafico">
        <div className="footer-left-grafica">
          <div className="logo-grafica">
            <img src={logo} alt="logo" className="logo-biomercy2" />
          </div>
          <div className="footer-text-grafica">
            <p>Escanea el QR para leer el estudio completo</p>
            <p className="publication">
              publicado en la Gaceta Médica de Caracas
            </p>
          </div>
        </div>
        <div className="qr-placeholder">
          <img src={qr} alt="qr" className="chart-image-grafico-qr" />
        </div>
      </div>
    </div>
  );
};

export default Grafica;
